import {
  Button,
  CircularProgress,
  Link,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import DriverApi from "api/DriverApi";
import { Alert, AlertTitle } from "@material-ui/lab";

const Container = styled.div`
  width: 90%;
  margin: 50px auto;

  > * {
    margin-bottom: ${({ theme: { spacing } }) => spacing(2)}px;
  }
`;

const ResetPassword = () => {
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const queryString = new URLSearchParams(useLocation().search);
  const resetToken = queryString.get("token");
  const [email, setEmail] = useState();
  const [isSent, setIsSent] = useState(false);

  const onChangePassword = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPassword(event.target.value);
  };

  const onClickPostButton = async () => {
    if (!password) return;

    setLoading(true);
    await DriverApi.resetPassword(email, password);
    setLoading(false);
    setIsSent(true);
  };
  useEffect(() => {
    const getDriver = async () => {
      try {
        const result = await DriverApi.findByResetToken(resetToken || "");
        setEmail((result as any).email);
      } catch {
        history.push("/resetPassword/send");
      }
    };
    getDriver();
  }, []);

  return (
    <Container>
      <Typography>新しいパスワードを入力してください。</Typography>
      <TextField
        label="パスワード"
        required
        type="password"
        autoComplete="current-password"
        variant="filled"
        fullWidth
        onChange={onChangePassword}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={loading || isSent}
        onClick={onClickPostButton}
      >
        {loading ? <CircularProgress color="inherit" size={24} /> : "送信"}
      </Button>
      {isSent && (
        <Alert severity="success">
          <AlertTitle>パスワードを再設定しました。</AlertTitle>
          <Link href="/login">ログインページ</Link>
          へ遷移してログインしてください。
        </Alert>
      )}
    </Container>
  );
};
export default ResetPassword;
